const INDIVIDUAL = 'Individual';
const COMPANY = 'Company';
const ENTERPRISE = 'Enterprise';

export { COMPANY, ENTERPRISE, INDIVIDUAL };
